var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { candidateApplyJob, saveCustomerJobs } from '@/api';
import { likeJob } from '@/api/job.api';
import { ApplyJobModal, Button, ConformationModal, JobCard, JobCardSkeleton, JobCommentsDrawer, JobsEmptyState, SortDropDown, Text, } from '@/components';
import { BackToTopIcon } from '@/components/icons/back-to-top-icon';
import { useConfigContext, useCustomerDetailContext, useToast } from '@/hoc';
import { useMyJobsContext } from '@/hoc/context/my-jobs-context';
import { useIntersectionObserver, useMutation } from '@/hooks';
import { cn } from '@/utils';
import React, { useCallback, useEffect, useRef, useState } from 'react';
var defaultVoidFunction = function () {
    return;
};
export var MyJobsList = function (_a) {
    var _b = _a.isPreview, isPreview = _b === void 0 ? false : _b;
    var jobCard = useConfigContext().config.jobCard;
    var loadingTimeoutRef = useRef();
    var customerDetail = useCustomerDetailContext().customerDetail;
    var _c = useIntersectionObserver(), targetRef = _c[0], isIntersecting = _c[1];
    var _d = useIntersectionObserver(), lastCardRef = _d[0], isLastCardIntersecting = _d[1];
    var _e = useMyJobsContext(), jobs = _e.jobs, isLoading = _e.isLoading, isLoadingMore = _e.isLoadingMore, fetchNextPage = _e.fetchNextPage, refetchJobs = _e.refetchJobs, hasMore = _e.hasMore, setSortBy = _e.setSortBy, updateJob = _e.updateJob, setFilters = _e.setFilters;
    var _f = useState(null), selectedJobId = _f[0], setSelectedJobId = _f[1];
    var _g = useState(false), commentsModalVisible = _g[0], setCommentsModalVisible = _g[1];
    var _h = useState(false), applyModalVisible = _h[0], setApplyModalVisible = _h[1];
    var _j = useState(false), showConfirmationModal = _j[0], setShowConfirmationModal = _j[1];
    var _k = useState(''), confirmationMessage = _k[0], setConfirmationMessage = _k[1];
    var _l = useState(defaultVoidFunction), handleOkFunction = _l[0], setHandleOkFunction = _l[1];
    var showToast = useToast().showToast;
    var handleShowConfirmationModal = function (message, handleOk) {
        setConfirmationMessage(message);
        setHandleOkFunction(function () { return handleOk; });
        setShowConfirmationModal(true);
    };
    var cardContainerRef = useRef(null);
    useEffect(function () {
        if (isLastCardIntersecting && hasMore && !isLoadingMore && !isLoading) {
            // Clear any existing timeout
            if (loadingTimeoutRef.current) {
                clearTimeout(loadingTimeoutRef.current);
            }
            // Set a new timeout for fetching
            loadingTimeoutRef.current = setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    fetchNextPage();
                    return [2 /*return*/];
                });
            }); }, 1000); // 1 second throttle
        }
        return function () {
            if (loadingTimeoutRef.current) {
                clearTimeout(loadingTimeoutRef.current);
            }
        };
    }, [isLastCardIntersecting, hasMore, isLoadingMore, isLoading, fetchNextPage]);
    var handleScrollToTop = useCallback(function () {
        var _a;
        (_a = cardContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }, []);
    var likeJobMutation = useMutation({
        mutationFn: likeJob,
        onSuccess: function (_response, payload) {
            var job = jobs.find(function (j) { return j.jobId === payload.jobId; });
            if (!job)
                return;
            updateJob(payload.jobId, {
                jobLikedByCurrentUser: payload.liked,
                likesCount: payload.liked ? job.likesCount + 1 : job.likesCount - 1,
            });
        },
    }).mutate;
    var saveJobMutation = useMutation({
        mutationFn: saveCustomerJobs,
        onSuccess: function (_response, _a) {
            var payload = _a[0];
            if ((payload === null || payload === void 0 ? void 0 : payload.is_save) === false) {
                showToast({
                    message: 'Job unsaved successfully.',
                    status: 'success',
                });
            }
            else {
                showToast({
                    message: 'Job saved successfully.',
                    status: 'success',
                });
            }
            refetchJobs();
        },
    }).mutate;
    var candidateApplyJobMutation = useMutation({
        mutationFn: candidateApplyJob,
        onSuccess: function (_response, _a) {
            var payload = _a[0];
            if ((payload === null || payload === void 0 ? void 0 : payload.is_applied) === false) {
                showToast({
                    message: 'Application withdrawn successfully.',
                    status: 'success',
                });
            }
            else {
                showToast({
                    message: 'Application submitted successfully.',
                    status: 'success',
                });
            }
            refetchJobs();
        },
    }).mutate;
    var handleLikedJob = function (jobId, status) {
        likeJobMutation({ jobId: jobId, liked: status });
    };
    var handleSaveJobs = function (jobId) {
        saveJobMutation([{ job_id: jobId }]);
    };
    var handleUnSaveJobs = function (jobId) {
        handleShowConfirmationModal('You want to remove this job from your saved jobs?', function () {
            saveJobMutation([{ job_id: jobId, is_save: false }]);
            setShowConfirmationModal(false);
        });
    };
    var handleApplyJob = function (jobId) {
        candidateApplyJobMutation([{ job_id: jobId }]);
    };
    var handleWithdrawJob = function (jobId) {
        handleShowConfirmationModal('You want to withdraw your application?', function () {
            candidateApplyJobMutation([{ job_id: jobId, is_applied: false }]);
            setShowConfirmationModal(false);
        });
    };
    if (isLoading && !(jobs === null || jobs === void 0 ? void 0 : jobs.length)) {
        return (_jsxs("div", { className: "grid gap-4 pb-4 py-0 vjwMd:py-2 h-full w-full items-stretch grid-cols-1 md:grid-cols-noOfJobCardsPerRow", ref: cardContainerRef, children: [__spreadArray([], Array(5), true).map(function (_, index) { return (_jsx(JobCardSkeleton, { targetRef: index === 0 ? targetRef : undefined }, index)); }), !isIntersecting && !isPreview && (_jsx(Button, { onClick: handleScrollToTop, className: cn('fixed bottom-4 z-100000 left-4 vjwMd:left-auto vjwMd:right-80 shadow-lg px-2 py-2 rounded-md vjwMd:rounded-full bg-vjwSecondary text-vjwPrimary hover:bg-gray-200 ring-1 vjwMd:ring-none vjwMd:bg-vjwPrimary vjwMd:text-white vjwMd:hover:bg-vjwPrimary'), children: _jsx(BackToTopIcon, {}) }))] }));
    }
    if (!(jobs === null || jobs === void 0 ? void 0 : jobs.length) && !isLoading) {
        return _jsx(JobsEmptyState, {});
    }
    return (_jsxs("div", { className: 'flex gap-2 pb-4 py-0 vjwMd:py-2 flex-wrap w-full', ref: cardContainerRef, children: [_jsx("div", { className: cn('flex gap-2 items-center ml-auto'), children: (jobCard === null || jobCard === void 0 ? void 0 : jobCard.allowSorting) && (_jsx(SortDropDown, { showRecommended: !!customerDetail, showPostedDate: true, matchScoreAsRelevant: !!customerDetail, showRelevant: !!customerDetail, sortByValue: customerDetail ? 'Recommended' : 'Posted Date', handleSortByDefault: function () { return setSortBy('recommended'); }, handleSortByDesignation: function () { return setSortBy('designation'); }, handleSortByMatchScore: function () { return setSortBy('relevant'); }, handleSortByPostedDate: function () { return setSortBy('posted_date'); } })) }), _jsxs("div", { className: "grid gap-2 pb-4 py-0 vjwMd:py-2 h-full w-full items-stretch grid-cols-1 md:grid-cols-noOfJobCardsPerRow", children: [jobs.map(function (job, index) { return (_jsx(JobCard, { details: job, targetRef: index === 0
                            ? targetRef
                            : index === jobs.length - 1 && !isLoadingMore
                                ? lastCardRef
                                : undefined, handleLikedJob: handleLikedJob, setSelectedJobId: setSelectedJobId, setCommentsModalVisible: setCommentsModalVisible, saveJob: handleSaveJobs, applyJob: handleApplyJob, setApplyModalVisible: setApplyModalVisible, isSkillChipFilterable: true, setFilters: setFilters, handleAppliedJob: handleWithdrawJob, isMyJobs: job.isApplied, getBackId: handleUnSaveJobs }, job.jobId)); }), isLoadingMore && __spreadArray([], Array(5), true).map(function (_, index) { return _jsx(JobCardSkeleton, {}, index); })] }), !isIntersecting && !isPreview && (_jsx(Button, { onClick: handleScrollToTop, className: cn('fixed cursor-pointer bottom-4 z-100001 left-4 vjwMd:left-auto right-auto vjwMd:right-4 shadow-lg px-2 py-2 rounded-md vjwMd:rounded-full bg-vjwSecondary text-vjwPrimary hover:bg-gray-200 ring-1 vjwMd:ring-none vjwMd:bg-vjwPrimary vjwMd:text-white vjwMd:hover:bg-vjwPrimary'), children: _jsx(BackToTopIcon, {}) })), !hasMore && (_jsx(Text, { className: 'w-full p-4 text-center', children: "You've reached the end of the job list." })), selectedJobId && commentsModalVisible && (_jsx(JobCommentsDrawer, { isDrawerOpen: commentsModalVisible, jobId: selectedJobId, onCloseDrawer: function () { return setCommentsModalVisible(false); } })), selectedJobId && applyModalVisible && (_jsx(ApplyJobModal, { isOpen: applyModalVisible, onClose: function () { return setApplyModalVisible(false); }, jobId: selectedJobId })), showConfirmationModal && (_jsx(ConformationModal, { isOpen: showConfirmationModal, onClose: function () { return setShowConfirmationModal(false); }, message: confirmationMessage, handleOk: handleOkFunction }))] }));
};
